export const APP_ROUTES = {
  AUTH: 'auth',
  DASHBOARD: 'dashboard',
  GAMES: 'games',
  ALL_GAMES: 'all-games',
  CREATE_GAME: 'create-game',
  EDIT_GAME: 'edit-game',
  SPORT_EVENTS: 'sport-events',
  CUSTOM_LEADERBOARDS: 'custom-leaderboards',
  CRM: 'crm',
  CMS: 'cms',
  PLAYERS: 'players',
  GROUPS: 'groups',
  FEATURE_FLAGS: 'feature-flags',
  LANGUAGES: 'languages',
  TRANSLATIONS: 'translations',
  INFO_POPUP: 'info-popup',
  INFO_PAGE: 'info-page',
  ONBOARDING: 'onboarding',
  SETTINGS: 'settings',
  PORTAL: 'v',
  PORTAL_ADMIN: 'a',
  RESTORE_PASSWORD: 'restorePassword',
  ADMIN: 'admin',
  VENDORS: 'vendors',
  STREAK_SETUP: 'streak-setup',
  QUESTIONS: 'questions',
  STREAK_DASHBOARD: 'streak-dashboard',
  STREAK_GAMES: 'streak-games',
  ALL_STREAK_GAMES: 'all-streak-games',
  STREAK_CUSTOM_LEADERBOARDS: 'streak-custom-leaderboards',
  UPSELL: 'upsell',
  MAINTENANCE_MODE: 'maintenance-mode',
  WHITELISTED_USERS: 'whitelisted-users',
  BRACKET_GAMES: 'bracket-games',
  ALL_BRACKET_GAMES: 'all-bracket-games',
  BRACKET_SETUP: 'bracket-setup',
  BRACKET_DASHBOARD: 'bracket-dashboard',
  BRACKET_TEAMS: 'bracket-teams',
  HOW_TO_PLAY: 'how-to-play',
  CHALLENGES: 'challenges',
  UPSELL_CUSTOM: 'upsells-custom',
  UPSELL_DEFAULT: 'upsells-default',
  UPSELL_OVERLAY: 'upsells-overlay',
  UPSELLS: 'upsells',
  POWERUPS: 'powerups',
  TOURNAMENTS: 'tournaments',
  SEGMENT_POOLS: 'segment-pools',
  VENDOR_SETTINGS: 'vendor-settings',
  CACHE_MANAGEMENT: 'cache-management',
  CONNECT3_GAMES: 'connect3-games',
  ALL_CONNECT3_GAMES: 'all-connect3-games',
  CONNECT3_SETUP: 'connect3-setup',
  CONNECT3_SHEET_BUILDER: 'connect3-sheet-builder',
  CONNECT3_PRICING: 'connect3-pricing',
  CONNECT3_MARKETS: 'connect3-markets',
  CONNECT3_MARKETS_FAMILY: 'connect3-markets-family',
  PASS_THE_BALL_GAMES: 'pass-the-ball-games',
  ALL_PASS_THE_BALL_GAMES: 'all-pass-the-ball-games',
  PASS_THE_BALL_MARKETS: 'pass-the-ball-markets',
  PASS_THE_BALL_AVATARS: 'pass-the-ball-avatars',
  PASS_THE_BALL_ONBOARDING: 'pass-the-ball-onboarding',
  MONEY_HEIST_ROUNDS: 'money-heist-rounds'
};
